import FormattedMessage from 'I18n/components/FormattedMessage';
import { MISSING_SCOPE, RESTRICTED_BY_SOURCE_APP } from 'automation-ui-permissions/feature-permissions/constants/DisabledReasons';
import * as WorkflowManagementFeatureKeys from 'automation-ui-permissions/feature-permissions/constants/WorkflowManagementFeatures';
import { BULK_SELECT } from 'automation-ui-permissions/feature-permissions/constants/FeatureContexts';
import { jsx as _jsx } from "react/jsx-runtime";
export const DISABLED_FEATURE_CONTEXT_MESSAGES = {
  [WorkflowManagementFeatureKeys.ASSIGN_TEAM]: {
    [BULK_SELECT]: {
      [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-permissions.disabledFeatures.bulkSelect.missingScope"
      }),
      [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-permissions.disabledFeatures.bulkSelect.restrictedBySourceApp"
      })
    }
  },
  [WorkflowManagementFeatureKeys.DELETE]: {
    [BULK_SELECT]: {
      [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-permissions.disabledFeatures.bulkSelect.missingScope"
      }),
      [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-permissions.disabledFeatures.bulkSelect.restrictedBySourceApp"
      })
    }
  },
  [WorkflowManagementFeatureKeys.MOVE]: {
    [BULK_SELECT]: {
      [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-permissions.disabledFeatures.bulkSelect.missingScope"
      }),
      [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-permissions.disabledFeatures.bulkSelect.restrictedBySourceApp"
      })
    }
  }
};
export const getDisabledFeatureContextMessage = ({
  feature,
  disabledReason,
  featureContext
}) => {
  if (featureContext && disabledReason && DISABLED_FEATURE_CONTEXT_MESSAGES[feature] && DISABLED_FEATURE_CONTEXT_MESSAGES[feature][featureContext]) {
    return DISABLED_FEATURE_CONTEXT_MESSAGES[feature][featureContext][disabledReason] || null;
  }
  return null;
};